// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as Rxjs from "../../Rxjs.bs.jsx";
import * as Rxjs$1 from "rxjs";
import * as React from "react";
import * as Header from "../../components/Header/Header.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as DateUtils from "../../utils/DateUtils.bs.jsx";
import * as KegAddNew from "./KegAddNew.bs.jsx";
import * as KegDetail from "./KegDetail.bs.jsx";
import * as UserRoles from "../../backend/UserRoles.bs.jsx";
import * as Reactfire from "reactfire";
import * as PlaceStats from "./PlaceStats.bs.jsx";
import * as ChargedKegs from "./ChargedKegs.bs.jsx";
import * as PlaceHeader from "../../components/PlaceHeader/PlaceHeader.bs.jsx";
import * as TapsSetting from "./TapsSetting.bs.jsx";
import * as Auth from "rxfire/auth";
import * as BackendUtils from "../../utils/BackendUtils.bs.jsx";
import * as DepletedKegs from "./DepletedKegs.bs.jsx";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as BasicInfoDialog from "./BasicInfoDialog.bs.jsx";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Firestore from "rxfire/firestore";
import * as FormattedCurrency from "../../components/FormattedCurrency/FormattedCurrency.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as Firestore$1 from "firebase/firestore";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.jsx";
import * as UsePaginatedDepletedKegsData from "./UsePaginatedDepletedKegsData.bs.jsx";

function pageDataRx(auth, firestore, placeId) {
  let placeRef = Db.placeDocument(firestore, placeId);
  let placeRx = Rxjs.op(Firestore.docData(placeRef, { "idField": "uid" }), Rxjs.keepSome);
  let personsAllRx = Db.PersonsIndex.allEntriesSortedRx(firestore, placeId);
  let chargedKegsRx = Db.allChargedKegsRx(firestore, placeId);
  let currentUserRx = Rxjs.op(Auth.user(auth), Rxjs.keepMap(prim => {
    if (prim === null) {
      return;
    } else {
      return Primitive_option.some(prim);
    }
  }));
  return Rxjs$1.combineLatest(placeRx, personsAllRx, chargedKegsRx, currentUserRx);
}

function PlaceSetting(props) {
  let placeId = props.placeId;
  let auth = Reactfire.useAuth();
  let firestore = Reactfire.useFirestore();
  let match = UsePaginatedDepletedKegsData.use(undefined, placeId);
  let pageDataStatus = Reactfire.useObservable(`Page_PlaceSetting_` + placeId, pageDataRx(auth, firestore, placeId));
  let match$1 = React.useState(() => "Hidden");
  let setDialog = match$1[1];
  let dialogState = match$1[0];
  let hideDialog = param => setDialog(param => "Hidden");
  let match$2 = pageDataStatus.data;
  if (match$2 === undefined) {
    return null;
  }
  let chargedKegs = match$2[2];
  let personsAll = match$2[1];
  let place = match$2[0];
  let match$3 = Stdlib_Option.getOrThrow(place.accounts[match$2[3].uid], undefined);
  let currentUserRole = match$3[0];
  let isUserAuthorized = extra => UserRoles.isAuthorized(currentUserRole, extra);
  let kegsOnTapUids = Stdlib_Array.filterMap(Object.values(place.taps), maybeKegReference => Stdlib_Option.map(maybeKegReference === null ? undefined : Primitive_option.some(maybeKegReference), ref => ref.id));
  let match$4 = Stdlib_Array.partition(chargedKegs, keg => kegsOnTapUids.includes(Db.getUid(keg)));
  let tmp;
  if (typeof dialogState !== "object") {
    switch (dialogState) {
      case "Hidden" :
        tmp = null;
        break;
      case "AddKeg" :
        tmp = <KegAddNew.make
          onDismiss={hideDialog}
          onSubmit={param => {
            let price = param.price;
            let resolvedDonors;
            if (param.ownerIsDonor) {
              let placeOwnerUid = Stdlib_Option.getOrThrow(Object.entries(place.accounts).find(param => param[1][0] === 100), undefined)[0];
              let placeOwnerPersonId = Stdlib_Option.getOrThrow(personsAll.find(param => {
                  let userId = param[1].userId;
                  if (userId !== null) {
                    return userId === placeOwnerUid;
                  } else {
                    return false;
                  }
                }), undefined)[0];
              resolvedDonors = Object.fromEntries([[
                  placeOwnerPersonId,
                  price
                ]]);
            } else {
              resolvedDonors = param.donors;
            }
            Firestore$1.addDoc(Db.placeKegsCollection(firestore, placeId), {
              beer: param.beer,
              consumptions: {},
              createdAt: Firestore$1.Timestamp.now(),
              depletedAt: null,
              donors: resolvedDonors,
              milliliters: param.milliliters,
              price: price,
              recentConsumptionAt: null,
              serial: param.serial
            });
            setDialog(param => "Hidden");
          }}
          personsAll={personsAll}
          placeId={placeId}
        />;
        break;
      case "BasicInfoEdit" :
        tmp = <BasicInfoDialog.make
          initialValues={{
            createdAt: DateUtils.toIsoDateString(place.createdAt.toDate()),
            name: place.name
          }}
          onDismiss={hideDialog}
          onPlaceDelete={() => {
            Db.Place.$$delete(firestore, placeId);
            RescriptReactRouter.replace("/misto");
          }}
          onSubmit={values => {
            Db.Place.update(firestore, placeId, Firestore$1.Timestamp.fromDate(DateUtils.fromIsoDateString(values.createdAt)), values.name);
            setDialog(param => "Hidden");
          }}
        />;
        break;
    }
  } else {
    let kegId = dialogState._0;
    let currentIdx = chargedKegs.findIndex(keg => Db.getUid(keg) === kegId);
    let hasNext = currentIdx !== -1 && currentIdx < (chargedKegs.length - 1 | 0);
    let hasPrevious = currentIdx > 0;
    let handleCycle = increase => {
      let allowed = increase ? hasNext : hasPrevious;
      if (!allowed) {
        return;
      }
      let nextIdx = currentIdx + (
        increase ? 1 : -1
      ) | 0;
      let nextKegId = Db.getUid(Stdlib_Option.getOrThrow(chargedKegs[nextIdx], undefined));
      setDialog(param => ({
        TAG: "KegDetail",
        _0: nextKegId
      }));
    };
    let formatConsumption = BackendUtils.getFormatConsumption(place.consumptionSymbols);
    let keg = Stdlib_Option.getOrThrow(chargedKegs[currentIdx], undefined);
    tmp = <KegDetail.make
      formatConsumption={formatConsumption}
      hasNext={hasNext}
      hasPrevious={hasPrevious}
      isUserAuthorized={isUserAuthorized}
      keg={keg}
      place={place}
      personsAllById={Object.fromEntries(personsAll)}
      onDeleteConsumption={consumptionId => {
        Db.Keg.deleteConsumption(firestore, placeId, kegId, consumptionId);
      }}
      onDeleteKeg={() => {
        Db.Keg.$$delete(firestore, placeId, kegId);
        setDialog(param => "Hidden");
      }}
      onDismiss={hideDialog}
      onFinalizeKeg={() => {
        Db.Keg.finalize(firestore, placeId, kegId);
        setDialog(param => "Hidden");
      }}
      onPreviousKeg={() => handleCycle(false)}
      onNextKeg={() => handleCycle(true)}
    />;
  }
  return <FormattedCurrency.Provider.make
    value={place.currency}
  >
    <div
      className={Styles.page.narrow}
    >
      <PlaceHeader.make
        buttonRightSlot={UserRoles.isAuthorized(currentUserRole, 100) ? <button
            className={Header.classes.buttonRight}
            type={"button"}
            onClick={param => setDialog(param => "BasicInfoEdit")}
          >
            <span>
              {"✏️"}
            </span>
            <span>
              {"Změnit"}
            </span>
          </button> : null}
        createdTimestamp={place.createdAt}
        placeName={place.name}
      />
      <main>
        <PlaceStats.make
          chargedKegsValue={Stdlib_Array.reduce(chargedKegs, 0, (sum, keg) => sum + keg.price | 0)}
          isUserAuthorized={isUserAuthorized}
          personsCount={personsAll.length}
        />
        <TapsSetting.make
          place={place}
          placeId={placeId}
          tappedChargedKegs={match$4[0]}
          untappedChargedKegs={match$4[1]}
        />
        <ChargedKegs.make
          chargedKegs={chargedKegs}
          onAddNewKeg={() => setDialog(param => "AddKeg")}
          onKegDetail={kegId => setDialog(param => ({
            TAG: "KegDetail",
            _0: kegId
          }))}
        />
        <DepletedKegs.make
          maybeFetchMoreDepletedKegs={match[1]}
          maybeDepletedKegs={match[0]}
        />
      </main>
    </div>
    {tmp}
  </FormattedCurrency.Provider.make>;
}

let make = PlaceSetting;

export {
  pageDataRx,
  make,
}
/* Db Not a pure module */
